<template>

<b-modal v-model="modalShow"
         centered
         :title="$t('labels.createClient')"
         hide-footer
         size="lg"
         no-close-on-backdrop>

    <b-overlay :show="loadingData" variant="transparent" no-wrap />

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>

          <b-col md="6">
            <b-form-group :label="$t('labels.name')">
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >
                <b-form-input
                  v-model="formData.client.name"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.description')">
              <validation-provider
                #default="{ errors }"
                name="description"
                rules="required"
              >
                <b-form-input
                  v-model="formData.client.description"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('labels.description')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.currencies')">
              <validation-provider
                      #default="{ errors }"
                      name="Currencies"
                      rules="required"
              >

                <v-select
                        v-model="formData.activeCurrencies"
                        @input="setFormDefaultCurrency()"
                        :placeholder="$t('labels.currencies')"
                        label="name"
                        :reduce="currency => currency._id"
                        multiple
                        :close-on-select="false"
                        :options="currencies"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
              <b-form-group :label="$t('labels.adminUsername')">
                <validation-provider
                        #default="{ errors }"
                        name="Admin Username"
                        rules="required"
                >
                  <b-form-input
                          v-model="formData.admin.username"
                          :state="errors.length > 0 ? false : null"
                          :placeholder="$t('labels.adminUsername')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.adminPassword')">
              <validation-provider
                      #default="{ errors }"
                      name="password"
                      :rules="{ required: true, min: 8 }"
              >
                <b-form-input
                        type="password"
                        v-model="formData.admin.password"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('labels.adminPassword')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('labels.adminEmail')">
              <validation-provider
                      #default="{ errors }"
                      name="Admin Email"
                      rules="required|email"
              >
                <b-form-input
                        v-model="formData.admin.email"
                        :state="errors.length > 0 ? false : null"
                        :placeholder="$t('labels.adminEmail')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationForm"
            >
              {{$t('buttons.submit')}}
            </b-button>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>

</b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BCardText, VBModal, BCard, BOverlay
} from 'bootstrap-vue'
import { required, integer, min } from '@validations'
import { mapActions  } from 'vuex'
import { BFormCheckbox } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name : 'addUpdateClient',

  components: {
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BCard,
    vSelect,
    VBModal,
    BOverlay,
    ToastificationContent
  },

  directives: {
    'b-modal': VBModal,
    Ripple,
  },

  data() {
    return {
        modalShow: false,
     formData: {
       client: {
         name: null,
         description: null,
       },
        admin : {
          username : null,
          password : null,
          email : null
        },
       activeCurrencies : [],
       defaultCurency : ''
     },
      required,
      integer,
      loadingData: false,
      currencies : []
    }
  },

  methods: {
    ...mapActions("client", ["store", "clients"]),
    ...mapActions('currency', ['currencys']),

    setFormDefaultCurrency(){
      if(Array.isArray(this.formData.activeCurrencies) && this.formData.activeCurrencies.length > 0){
        this.formData.defaultCurency = this.formData.activeCurrencies[0]
      }
    },

    async validationForm() {
      this.$refs.simpleRules.validate()
      .then(async (success) => {
        if (success) {
          try {
            this.loadingData = true
            await this.store(this.formData)
            this.modalShow = false
            this.$toast({
               component: ToastificationContent,
                props: {
                  title: this.$t('labels.clientAdded'),
                  icon: "CheckCircleIcon",
                  variant: "success",
                },
              });
             await this.clients()
            this.resetFormData()
          } catch (error) {
              this.$toast({
                component: ToastificationContent,
                props: {
                    title: this.$t('labels.errorAddingClient'),
                    icon: "AlertTriangleIcon",
                    variant: "danger",
                    text: Array.isArray(error.errors) && error.errors.length > 0 ?
                        error.errors[0].field + ' ' + error.errors[0].message : error.message,
                },
                });
            console.log(error)
          }finally{
            this.loadingData = false
          }   
        }
      })
      .catch((error) => {
        this.$swal({
          title: this.$t('labels.error'),
          text: error.message,
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },

    resetFormData(){
      this.formData = {
        client: {
          name: null,
          description: null,
        },
        admin : {
          username : null,
          password : null,
          email : null
        },
        activeCurrencies : null,
        defaultCurency : ''
      }
    },

  },

 created() {
    this.currencys()
            .then(response =>{
              this.currencies = response
            })
  },

}
</script>
